import { CurrencyFilterType, DateFilterType, NumberFilterType, TextFilterType, TimeFilterType, ValuationPercentageFilterType } from '../datasets/instances/store/filterTypes';

export const initialTextFilter: TextFilterType = { value: null, isFuzzyMatchFilter: false };
export const initialNumberFilter: NumberFilterType = { value: undefined, comparator: null };
export const initialTimeFilter: TimeFilterType = { value: null, comparator: null, city: null };
export const initialDateFilter: DateFilterType = { from: null, to: null };
export const initialValuationPercentageFilter: ValuationPercentageFilterType = { percentage: undefined, comparator: null, containsMaturity: undefined };
export const initialCurrencyFilter: CurrencyFilterType = { value: undefined, comparator: null, currency: null };
